import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import OutboxOutlinedIcon from "@mui/icons-material/OutboxOutlined";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import { Tab, Tabs, alpha } from "@mui/material";
import { Link, useLocation } from "react-router";
import { getMomentPageSections } from "./moment-page-sections";

import type { MomentHeaderData } from "../../moment/hooks/use-moment-header";
import type { FC, ReactElement } from "react";

export const MomentPageNavigation: FC<{
  header: MomentHeaderData;
  ceAdmin: boolean;
}> = ({ header, ceAdmin }) => {
  const { pathname, search } = useLocation();
  const newsletter =
    pathname === `/moments/${header.id}/newsletter` ||
    pathname.startsWith(`/moments/${header.id}/newsletter/`);
  const base = `/moments/${header.id}/${newsletter ? "newsletter/" : ""}`;
  const section = pathname.slice(base.length).split("/")[0] || "details";
  const tabDetails: Record<string, { label: string; icon: ReactElement }> = {
    details: { label: "Edit", icon: <EditOutlinedIcon /> },
    review: { label: "Review", icon: <RateReviewOutlinedIcon /> },
    analytics: { label: "Analytics", icon: <AnalyticsOutlinedIcon /> },
    poll_results: { label: "Poll Results", icon: <PollOutlinedIcon /> },
    outbox: { label: "Outbox", icon: <OutboxOutlinedIcon /> },
  };
  const tabs = getMomentPageSections(header, ceAdmin).map((route) => ({
    route,
    ...tabDetails[route],
  }));

  const tabSearch = (route: string): string => {
    if (route === "analytics") return search;
    const params = new URLSearchParams(search);
    params.delete("view");
    params.delete("dimension");
    const next = params.toString();
    return next ? `?${next}` : "";
  };

  return (
    <Tabs
      indicatorColor="primary"
      scrollButtons={false}
      textColor="primary"
      value={tabs.some(({ route }) => route === section) ? section : false}
      variant="scrollable"
      sx={{
        height: 56,
        minHeight: 56,
        flexShrink: 0,
        borderBottom: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
        "& .MuiTabs-indicator": { height: 2 },
      }}
    >
      {tabs.map(({ label, route, icon }) => (
        <Tab
          key={route}
          label={label}
          icon={icon}
          iconPosition="start"
          value={route}
          component={Link}
          to={`${base}${route}${tabSearch(route)}`}
          sx={{
            height: 56,
            minHeight: 56,
            minWidth: 0,
            px: 2,
            py: 1,
            fontSize: "0.875rem",
            fontWeight: 400,
            lineHeight: 1.57,
            textTransform: "none",
            "&.Mui-selected": {
              bgcolor: (theme) =>
                alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
            },
            "& .MuiTab-iconWrapper": { mr: 0.5, mb: "0 !important", fontSize: 16 },
          }}
        />
      ))}
    </Tabs>
  );
};
